import { api } from '@/api';

/**
 * Request body for `admin-utils/edit-org-case-retention-times`. Applies to the
 * organisation the global admin has currently switched into (see the org
 * switcher in the account menu). The backend responds with an empty `{}`.
 */
export interface EditOrgCaseRetentionTimesProps {
  retentionInWeeksPostCaseClosure: number;
  retentionInWeeksPostFirstRecordUpload: number;
}

export type EditOrgCaseRetentionTimesResponse = object;

const editOrgCaseRetentionTimesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postEditOrgCaseRetentionTimes: builder.query<EditOrgCaseRetentionTimesResponse, EditOrgCaseRetentionTimesProps>({
      query: (props: EditOrgCaseRetentionTimesProps) => ({
        url: `admin-utils/edit-org-case-retention-times`,
        method: 'POST',
        body: {
          retention_in_weeks_post_case_closure: props.retentionInWeeksPostCaseClosure,
          retention_in_weeks_post_first_record_upload: props.retentionInWeeksPostFirstRecordUpload,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostEditOrgCaseRetentionTimesQuery } = editOrgCaseRetentionTimesApi;
